/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
import { registerBlockType } from '@wordpress/blocks';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * All files containing `style` keyword are bundled together. The code used
 * gets applied both to the front of your site and to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './style.scss';

/**
 * Internal dependencies
 */
import Edit from './edit';
import save from './save';
import metadata from './block.json';

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType( metadata.name, {
	icon: {
		src: (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
				<rect
					x="4"
					y="6"
					width="24"
					height="8"
					rx="2"
					ry="2"
					stroke="#325ce8"
					stroke-width="1.5"
					fill="none"
				/>
				<line
					x1="6"
					y1="10"
					x2="18"
					y2="10"
					stroke="#325ce8"
					stroke-width="1.5"
					stroke-linecap="round"
				/>

				<rect
					x="4"
					y="18"
					width="24"
					height="8"
					rx="2"
					ry="2"
					stroke="#325ce8"
					stroke-width="1.5"
					fill="none"
				/>
				<line
					x1="6"
					y1="22"
					x2="18"
					y2="22"
					stroke="#325ce8"
					stroke-width="1.5"
					stroke-linecap="round"
				/>
			</svg>
		),
	},
	/**
	 * @see ./edit.js
	 */
	edit: Edit,

	/**
	 * @see ./save.js
	 */
	save,
} );
